var _path, _path2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 176,
    viewBox: "0 0 244 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.681 33.9068C201.681 30.7772 200.753 27.7179 199.014 25.1158C197.276 22.5137 194.805 20.4856 191.913 19.288C189.022 18.0904 185.84 17.777 182.771 18.3875C179.702 18.9981 176.882 20.5051 174.669 22.718C172.456 24.9309 170.949 27.7504 170.339 30.8198C169.728 33.8892 170.042 37.0707 171.239 39.9621C172.437 42.8534 174.465 45.3246 177.067 47.0633C179.669 48.802 182.728 49.73 185.858 49.73C190.055 49.73 194.079 48.0629 197.047 45.0955C200.014 42.128 201.681 38.1033 201.681 33.9068Z",
    fill: "#D7ECF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241.508 84.8313C237.569 109.632 216.022 125.318 205.833 132.237H25.866C15.6223 129.538 7.16514 122.75 3.1223 113.69C-1.43956 103.464 -0.00817358 91.1608 7.09412 83.2838C16.6604 72.6402 28.7943 78.7178 38.0874 69.3697C49.8444 57.5475 35.6289 42.6032 45.9764 23.5113C53.0896 10.3395 66.6714 -0.960889 82.1653 0.0647846C94.8894 0.901518 113.852 9.71871 131.603 33.804C146.78 54.4165 162.044 58.9465 166.022 59.9542C197.217 67.8672 221.294 42.6752 235.957 53.0219C247.851 61.3848 242.327 79.649 241.508 84.8313Z",
    fill: "#D7ECF2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_4325_35782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0403 22.6958H161.09C169.566 22.6958 176.5 29.5811 176.5 37.9965V160.402L122.565 137.451L68.6304 160.402V37.9965C68.6304 29.5811 75.5649 22.6958 84.0403 22.6958Z",
    fill: "#26B0DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M85.7368 29.5811C79.0159 29.5811 75.4836 35.6403 74.5949 47.2414C74.5203 48.2146 75.7581 48.3965 76.0065 47.4526L76.573 45.2993C78.4619 38.1195 93.1609 29.5811 85.7368 29.5811Z",
    fill: "#C0E6EC",
    stroke: "#C0E6EC",
    strokeWidth: 1.14755,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.861 22.6958C119.923 31.153 109.947 44.2386 105.678 60.3566L91.8705 112.494C88.4722 125.326 89.1686 138.279 93.1544 149.966L122.565 137.451L176.5 160.402V37.9965C176.5 29.5811 169.566 22.6958 161.09 22.6958H132.861Z",
    fill: "#0093C6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4325_35782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.694 138.157L122.565 121.46L83.436 138.157V46.2443C83.436 42.0317 86.9577 38.585 91.2619 38.585H153.869C158.173 38.585 161.694 42.0317 161.694 46.2443V138.157Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M214.77 11.065C214.77 9.77026 214.386 8.50459 213.666 7.42818C212.946 6.35178 211.924 5.51302 210.727 5.01805C209.531 4.52308 208.215 4.39415 206.945 4.64757C205.675 4.90099 204.509 5.52537 203.594 6.44171C202.68 7.35804 202.057 8.52513 201.806 9.7953C201.555 11.0655 201.686 12.3816 202.183 13.5772C202.68 14.7727 203.521 15.794 204.598 16.5117C205.676 17.2294 206.942 17.6113 208.237 17.6091C209.096 17.6091 209.946 17.4397 210.74 17.1107C211.533 16.7817 212.254 16.2995 212.86 15.6917C213.467 15.0839 213.948 14.3624 214.276 13.5685C214.603 12.7746 214.771 11.9239 214.77 11.065Z",
    fill: "#D7ECF2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_4325_35782",
    x: 54.8598,
    y: 10.0727,
    width: 135.411,
    height: 165.247,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.14755,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4325_35782"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.2951
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.44265
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4325_35782"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.14755
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.8853
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4325_35782",
    result: "effect2_dropShadow_4325_35782"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.5902
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.44265
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_4325_35782",
    result: "effect3_dropShadow_4325_35782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_4325_35782",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4325_35782",
    x: 79.9934,
    y: 36.2899,
    width: 85.1436,
    height: 106.458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.14755
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.72133
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4325_35782"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4325_35782",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/NoResults.96af3b2d765281587ea1dfb494866c56.svg";
export { ForwardRef as ReactComponent };